import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { normalizeIds } from '@/utils/ids';

import { TWorkspaceSimpleEntity } from '../types';

import { workspaceQueryKeys } from './query-keys';

export async function getWorkspacesByIds(ids: string[]): Promise<TWorkspaceSimpleEntity[]> {
  return acceso360Client
    .get('/monitoring/api/v1/workspaces/by_ids', { params: { ids: ids.join(',') } })
    .then(({ data }) => data);
}

type QueryFnType = typeof getWorkspacesByIds;

interface UseWorkspacesByIdsParams {
  ids: string[];
  config?: Omit<QueryConfig<QueryFnType>, 'enabled'>;
}

export function useWorkspacesByIds({ ids, config = {} }: UseWorkspacesByIdsParams) {
  const uniqueIds = normalizeIds(ids);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: workspaceQueryKeys.workspacesByIds(uniqueIds),
    queryFn() {
      return getWorkspacesByIds(uniqueIds);
    },
    enabled: uniqueIds.length > 0,
  });
}
